/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ArchiveContactsRequest
 */
export interface ArchiveContactsRequest {
  /**
   *
   * @type {boolean}
   * @memberof ArchiveContactsRequest
   */
  archive?: boolean
  /**
   *
   * @type {Array<string>}
   * @memberof ArchiveContactsRequest
   */
  ids?: Array<string>
}

export function ArchiveContactsRequestFromJSON(json: any): ArchiveContactsRequest {
  return ArchiveContactsRequestFromJSONTyped(json, false)
}

export function ArchiveContactsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArchiveContactsRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    archive: !exists(json, 'archive') ? undefined : json['archive'],
    ids: !exists(json, 'ids') ? undefined : json['ids']
  }
}

export function ArchiveContactsRequestToJSON(value?: ArchiveContactsRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    archive: value.archive,
    ids: value.ids
  }
}
